<template>
  <main-layout>
    <b-overlay :show="show">
      <b-row class="d-flex align-items-center m-4">
        <b-col md="3" class="text-center">
          <img class="border"
               :src="produit.image ? `https://www.luqei.com/images/cours/${produit.image}.jpg` : 'https://www.luqei.com/images/cours/place_holder.jpg'"
               alt=""
               width="220px"
               style="max-width: 100%">
        </b-col>
        <b-col md="auto">
          <h2 class="text-primary mt-3 mt-sm-0">{{ produit.titre }}</h2>
          <hr>
          <h4 class="text-secondary h4 font-weight-light">
            {{ formatType(produit.type) }}<br>
            Niveau : <b>{{ produit.niveau }}</b><br>
            Prix : <b>{{ produit.prix }} €</b><br><br>
            <a :href="produit.adresse_paypal" v-if="!produit.achat">
              <button type="button" class="btn btn-danger shadow-sm border p-2">Acheter</button>
            </a>
            <router-link :to="{name:'TexteVue', params:{id:produit.texte}}" v-else>
              <b-btn variant="primary" class="shadow-sm border p-2">Faire l'exercice</b-btn>
            </router-link>
          </h4>
        </b-col>
      </b-row>
      <hr/>
      <div class="m-4" v-html="produit.description"></div>
      <hr/>
      <div class="m-4" v-if="produit.type === 'PE'" style="max-width: 1400px">
        <p><b>Exemple d'exercice écrit et corrigé</b></p>
        <img class="d-none d-sm-block" src="https://www.luqei.com/images/landing/exemple_exercice.jpg" alt=""
             width="100%"/>
        <img class="d-block d-sm-none" src="https://www.luqei.com/images/landing/exemple_exercice_mini.jpg" alt=""
             width="100%"/>
      </div>
    </b-overlay>
  </main-layout>
</template>

<script>
import MainLayout from "@/components/Nav/MainLayout";
import {Produit} from "@/js/caller";
import {formatType} from "@/js/utils";

export default {
  name: "ProduitVue",
  components: {MainLayout},
  data() {
    return {
      show: true,
      produit: {},
    }
  },
  methods: {
    formatType,
  },
  created() {
    const {id} = this.$route.params;
    Produit.Get(id).then((res) => {
      this.show = false;
      const {id, ...other} = res.exercices[0]
      this.produit = {
        ...res,
        //Injection of the first exercice
        ...other
      };
    })
  }
}
</script>

<style scoped>
p {
  margin: 0 !important;
}
</style>